import { Component, forwardRef } from "@angular/core";
import { ModelService } from "../../../../Services/model.service";
import { StartAction } from "../../../../Model/Dto/StartAction";
import { UserActionBaseComponent}  from "../userAction-base.component";
import { TranslateService } from "@ngx-translate/core";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { LoginService } from "app/Services/login.service";

@Component({
    selector: "userAction-deleteEmptyFeatures",
    templateUrl: "userAction-deleteEmptyFeatures.component.html",
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionDeleteEmptyFeaturesComponent) }
    ],
    standalone: false
})
export class UserActionDeleteEmptyFeaturesComponent extends UserActionBaseComponent  {

  deleteFeatureSystems: boolean = false;
  deleteInVariantFeatureSystem: boolean = false;
  ignoreMasterProducts:boolean = false;
  constructor(public loginService: LoginService, public macroService: MacroService, public jobService: JobService, public translate: TranslateService, public catalogService: CatalogService) {
    super(loginService, macroService);
  }

  createParameterStringAsJsonString() {
    return JSON.stringify(
      {
        deleteFeatureSystems: this.deleteFeatureSystems,
        deleteInVariantFeatureSystem: this.deleteInVariantFeatureSystem,
        ignoreMasterProducts: this.ignoreMasterProducts
      }
    );
  }


  public parseParameter(parameter: string) {
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.deleteFeatureSystems = parsed.deleteFeatureSystems;
      this.deleteInVariantFeatureSystem = parsed.deleteInVariantFeatureSystem;
      this.ignoreMasterProducts = parsed.ignoreMasterProducts;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
